// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDAlert from "components/MDAlert";

import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "context";
import { useSessionContext } from "context/SessionContext";
import { useNotification } from "context/NotificationContext";

import { changeEmail } from "@shared/api/userInfo";

function ChangeEmail(): JSX.Element {
  const { t } = useContext(LanguageContext) as any;
  const { refresh, session, logout } = useSessionContext() as any; 
  const { showNotification } = useNotification();
  const navigate = useNavigate();
  
  const [newEmail, setNewEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleClick = async () => {
    try {
      setErrorMessage("");

      if (!newEmail || !confirmEmail) {
        setErrorMessage(t("Sttting-Email.require"));
        return;
      }

      if (newEmail !== confirmEmail) {
        setErrorMessage(t("Sttting-Email.require1"));
        return;
      }

      if (!session?.access_token) {
        await refresh();
      }
      const updated = await changeEmail(session.access_token, newEmail);
      console.log(`change-email::${JSON.stringify(updated)}`);

      showNotification({
        icon: "check_circle",
        title: t("Common.success"),
        message: t("Common.updated-success"),
      }, 2000);
      console.log(`update email success`);

      await logout();
      navigate("/pages/auth/Sign-In", { replace: true }); 

    } catch (err) {
      console.error("更新エラー", err);
      showNotification({
        icon: "error",
        title: t("Common.error"),
        message: t("Common.updated-error"),
      }, 2000);
    }
  };

  return (
    <Card id="change-email">
      <MDBox p={3}>
        <MDTypography variant="h5">{t("Sttting-Email.title")}</MDTypography>
      </MDBox>
      <MDBox component="form" pb={3} px={3}>
        {errorMessage && (
          <MDAlert color="error" dismissible>
            {errorMessage}
          </MDAlert>
        )}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MDInput
              fullWidth
              label={t("Sttting-Email.new-email")}
              value={newEmail}
              onChange={(e: any) => setNewEmail(e.target.value)}
              inputProps={{ type: "email", autoComplete: "email" }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              fullWidth
              label={t("Sttting-Email.confirm")}
              value={confirmEmail}
              onChange={(e: any) => setConfirmEmail(e.target.value)}
              inputProps={{ type: "email", autoComplete: "email" }}
            />
          </Grid>
        </Grid>
        <MDBox display="flex" justifyContent="space-between" alignItems="flex-end" flexWrap="wrap" mt={3}>
          <MDBox ml="auto">
            <MDButton variant="gradient" color="info" size="small" onClick={handleClick}>
              {t("Sttting-Email.update")}
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default ChangeEmail;